import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';

import { Office } from './types';
import { sortByName } from 'utils/array';

export const officeLoaders = getLoaders({
  list: {
    load: async (): Promise<Office[]> => {
      return executeApiCall({
        path: '/offices',
        method: 'get',
      });
    },

    defaultParser: sortByName,
  },
});
